import { render, staticRenderFns } from "./ServeSection.vue?vue&type=template&id=ea76c444&scoped=true"
import script from "./ServeSection.vue?vue&type=script&lang=js"
export * from "./ServeSection.vue?vue&type=script&lang=js"
import style0 from "./ServeSection.vue?vue&type=style&index=0&id=ea76c444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea76c444",
  null
  
)

export default component.exports